// extracted by mini-css-extract-plugin
export default {"inlineEvaluationIconContainer":"AIGradingActions__inlineEvaluationIconContainer___rbkIi"};